import type { EChartsOption } from "echarts";
import EChartBase from "./EChartBase";
import { defaultChartColors } from "./ChartTheme";

export type StackedBarDatum = {
  label: string;
  [series: string]: string | number;
};

type Props = {
  data: StackedBarDatum[];
  seriesKeys: string[];
  height?: number | string;
  horizontal?: boolean;
};

export default function StackedBarChart({
  data,
  seriesKeys,
  height = 320,
  horizontal = false,
}: Props) {
  const labels = data.map((x) => x.label);

  const option: EChartsOption = {
    color: defaultChartColors,
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    legend: { top: 0 },
    grid: { left: horizontal ? 120 : 45, right: 20, top: 50, bottom: 45 },
    xAxis: horizontal ? { type: "value" } : { type: "category", data: labels },
    yAxis: horizontal ? { type: "category", data: labels } : { type: "value" },
    series: seriesKeys.map((key) => ({
      name: key,
      type: "bar",
      stack: "total",
      data: data.map((x) => Number(x[key] || 0)),
    })) as any,
  };

  return <EChartBase option={option} height={height} empty={!data?.length} />;
}